import api, { handleResponse, handleError } from './api';

const introductionService = {
  async create({ targetAUserId, targetBUserId, note }) {
    try {
      return handleResponse(await api.post('/introductions', { targetAUserId, targetBUserId, note }));
    } catch (e) { return handleError(e); }
  },

  async get(introId) {
    try {
      return handleResponse(await api.get(`/introductions/${introId}`));
    } catch (e) { return handleError(e); }
  },

  async respond(introId, accept) {
    try {
      return handleResponse(await api.post(`/introductions/${introId}/respond`, { accept }));
    } catch (e) { return handleError(e); }
  },

  async getPending() {
    try {
      return handleResponse(await api.get('/introductions/pending'));
    } catch (e) { return handleError(e); }
  },

  async getQuota() {
    try {
      return handleResponse(await api.get('/introductions/quota'));
    } catch (e) { return handleError(e); }
  },
};

export default introductionService;
